import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Inquiry } from 'dashboard/models/inquiry';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import {
  InquiryTemplateVersion,
  InquiryTemplateVersionSchema,
} from 'dashboard/models/inquiry-template-version';
import { StepPreview } from 'lib/interfaces/StepsConfig';

export interface InquiryInspectState {
  inquiry: Inquiry | null;
  inquiryTemplateVersion: InquiryTemplateVersion | null;
  inquiryTemplate: InquiryTemplate | null;
  inquiryTemplateVersionSchema: InquiryTemplateVersionSchema | null;
  inquiryTemplateVersionStepsPreview: StepPreview[] | null;
}

export const initialState: InquiryInspectState = {
  inquiry: null,
  inquiryTemplateVersion: null,
  inquiryTemplate: null,
  inquiryTemplateVersionSchema: null,
  inquiryTemplateVersionStepsPreview: null,
};

interface SetInquiryPayload {
  inquiry: Inquiry | null;
}

interface SetInquiryTemplateVersionPayload {
  inquiryTemplateVersion: InquiryTemplateVersion;
}

interface SetInquiryTemplateVersionSchemaPayload {
  inquiryTemplateVersionSchema: InquiryTemplateVersionSchema;
}

interface SetInquiryTemplateVersionStepsPreviewPayload {
  inquiryTemplateVersionStepsPreview: StepPreview[];
}

interface SetInquiryTemplatePayload {
  inquiryTemplate: InquiryTemplate;
}

const { reducer, actions } = createSlice({
  name: 'inquiry-inspect',
  initialState,
  reducers: {
    setInquiry: (state, action: PayloadAction<SetInquiryPayload>) => {
      state.inquiry = castDraft(action.payload.inquiry);
    },
    setInquiryTemplateVersion: (state, action: PayloadAction<SetInquiryTemplateVersionPayload>) => {
      state.inquiryTemplateVersion = action.payload.inquiryTemplateVersion;
    },
    setInquiryTemplate: (state, action: PayloadAction<SetInquiryTemplatePayload>) => {
      state.inquiryTemplate = action.payload.inquiryTemplate;
    },
    setInquiryTemplateVersionSchema: (
      state,
      action: PayloadAction<SetInquiryTemplateVersionSchemaPayload>,
    ) => {
      state.inquiryTemplateVersionSchema = action.payload.inquiryTemplateVersionSchema;
    },
    setInquiryTemplateVersionStepsPreview: (
      state,
      action: PayloadAction<SetInquiryTemplateVersionStepsPreviewPayload>,
    ) => {
      state.inquiryTemplateVersionStepsPreview = action.payload.inquiryTemplateVersionStepsPreview;
    },
  },
});

export const {
  setInquiry,
  setInquiryTemplateVersion,
  setInquiryTemplate,
  setInquiryTemplateVersionSchema,
  setInquiryTemplateVersionStepsPreview,
} = actions;

export const inquiryInspectReducer = reducer;
